export const getLSItem = (key) => localStorage.getItem(key);
export const setLSItem = (key, value) => localStorage.setItem(key, value);
export const removeLSItem = (key) => localStorage.removeItem(key);

export const getLSBuildDate = () => getLSItem('build_date');
export const getLSDeviceToken = () => JSON.parse(getLSItem('deviceToken'));
export const getLSFetchBuildDate = () => getLSItem('fetch_build_date');
export const getLSLanguage = () => getLSItem('LANG');
export const getLSMinimizedActivities = () => JSON.parse(getLSItem('minimized_activities') || '{}');
export const getLSRefreshIndexedDB = () => getLSItem('refreshIndexDb');
export const getLSReportsTableView = () => getLSItem('reports_table_view');
export const getLSPWAModalSeen = () => getLSItem('PWAModalSeen');
export const getLSTreatmentProtocolsTab = () => getLSItem('treatment_protocols_tab');
export const getLSMyScheduleTab = () => getLSItem('my_schedule_tab');

export const removeLSRefreshIndexedDB = () => removeLSItem('refreshIndexDb');

export const setLSBuildDate = (buildDate) => setLSItem('build_date', buildDate);
export const setLSDeviceToken = (token) => setLSItem('deviceToken', JSON.stringify(token));
export const setLSFetchBuildDate = (buildDate) => setLSItem('fetch_build_date', buildDate);
export const setLSLanguage = (lang) => setLSItem('LANG', lang);
export const setLSMinimizedActivities = (activities) => setLSItem('minimized_activities', activities);
export const setLSNewContentAvailability = (availability) => setLSItem('is-new-content-available', availability);
export const setLSReportsTableView = (newMode) => setLSItem('reports_table_view', newMode);
export const setLSPWAModalSeen = (value) => setLSItem('PWAModalSeen', value);
export const setLSTreatmentProtocolsTab = (tab) => setLSItem('treatment_protocols_tab', tab);
export const setLSMyScheduleTab = (tab) => setLSItem('my_schedule_tab', tab);

export const isNewContentAvailable = () => {
  return getLSItem('is-new-content-available') === 'true';
};

// Manage visible fields — per-user table column preferences
const COLUMNS_ORDER_KEY = 'columnsOrder';

export const getColumnsFromStorage = (tableName) => JSON.parse(getLSItem(COLUMNS_ORDER_KEY) || '{}')[tableName];

export const setColumnsToStorage = (columns, tableName) => {
  const columnsOrder = JSON.parse(getLSItem(COLUMNS_ORDER_KEY) || '{}');
  setLSItem(COLUMNS_ORDER_KEY, JSON.stringify({ ...columnsOrder, [tableName]: columns }));
};
